"use client";
import React, { useContext } from "react";
import Product from "@/components/ui/product";
import SectionsHeader from "@/components/ui/sections-header";
import Container from "@/components/ui/Container";
import { cn } from "@/lib/cn";

import CofrretEssential from "@/assets/cofferts/coffret-essentiel.jpeg";
import CofrretEssentialPlus from "@/assets/cofferts/coffret-essentiel-plus.jpg";
import CofrretEssentialPremium from "@/assets/cofferts/coffret-essentiel-premium.jpg";
import { languageContext } from "@/contexts/language-context";
import productsTranslation from "@/translation/home/productsTranslation";

const products = [
  {
    name: "coffretEssential",
    image: CofrretEssential,
    isFlipping: false,
    gradient: "bg-gradient-to-r from-gray-100 to-slate-300",
    withBlur: false,
    price: 320,
    oldPrice: 420,
    checked: [
      {
        fr: "Coffret en similicuir à double utilisation",
        ar: "علبة جلد صناعي مزدوجة الاستخدام",
        en: "Dual-use faux leather box",
      },
      {
        fr: "Calendrier double face",
        ar: "تقويم ذو وجهين",
        en: "Double-sided calendar",
      },
      {
        fr: "Carte de visite digitale personnalisée",
        ar: "بطاقة عمل رقمية مخصصة",
        en: "Customized digital business card",
      },
      {
        fr: "Porte-feuille en cuir + stylo",
        ar: "محفظة جلدية + قلم",
        en: "Leather wallet + pen",
      },
    ],
    uncheked: [],
    link: "/commande-popcard-coffret-essentiel",
  },
  {
    name: "coffretEssentialPlus",
    image: CofrretEssentialPlus,
    isFlipping: false,
    gradient: "bg-gradient-to-r from-gray-100 to-slate-300",
    withBlur: false,
    price: 340,
    oldPrice: 450,
    checked: [
      {
        fr: "Coffret en similicuir à double utilisation",
        ar: "علبة من الجلد الصناعي للاستخدام المزدوج",
        en: "Dual-use faux leather box",
      },
      {
        fr: "Calendrier double face",
        ar: "تقويم ذو وجهين",
        en: "Double-sided calendar",
      },
      {
        fr: "Carte de visite digitale personnalisée",
        ar: "بطاقة عمل رقمية مخصصة",
        en: "Customized digital business card",
      },
      {
        fr: "Porte-feuille en cuir + stylo",
        ar: "محفظة جلدية + قلم",
        en: "Leather wallet + pen",
      },
    ],
    uncheked: [],
    link: "/commande-popcard-coffret-plus",
  },
  {
    name: "coffretPremium",
    image: CofrretEssentialPremium,
    isFlipping: false,
    gradient: "bg-gradient-to-r from-gray-100 to-slate-300",
    withBlur: false,
    price: 550,
    oldPrice: 650,
    checked: [
      {
        fr: "Coffret en similicuir à double utilisation",
        ar: "علبة من الجلد الصناعي للاستخدام المزدوج",
        en: "Dual-use faux leather box",
      },
      {
        fr: "Calendrier double face",
        ar: "تقويم ذو وجهين",
        en: "Double-sided calendar",
      },
      {
        fr: "Carte de visite digitale personnalisée",
        ar: "بطاقة عمل رقمية مخصصة",
        en: "Customized digital business card",
      },
      {
        fr: "Porte carte en cuir, Stylo, PowerBank, Clé USB",
        ar: "حافظة بطاقات جلدية، قلم، شاحن محمول، مفتاح USB",
        en: "Leather cardholder, pen, power bank, USB key",
      },
    ],
    uncheked: [],
    link: "/commande-popcard-coffret-premium",
  },
];

const Coffrets = ({
  showHeader = true,
  className,
}: {
  showHeader: boolean;
  className?: string;
}) => {
  const { lang } = useContext<any>(languageContext);
  return (
    <div className={cn("w-full relative py-[3rem] sm:py-[5rem]", className)}>
      <Container className={""}>
        {showHeader && (
          <SectionsHeader
            heading={productsTranslation.title[lang]}
            subHeading={productsTranslation.subtitle[lang]}
          />
        )}
      </Container>
      <Container className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 justify-items-center mt-8 px-0">
        {products.map((product, index) => {
          return (
            <Product
              key={product.name}
              product={product}
              index={index + 1}
              lang={lang}
            />
          );
        })}
      </Container>
    </div>
  );
};

export default Coffrets;
